import React from 'react';
import { useTranslation } from 'react-i18next';
import AssessmentPage from 'on_web/components/shared/AssessmentPage/AssessmentPage';
import { Grid, Typography, Box } from '@material-ui/core';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { makeStyles } from '@material-ui/core/styles';
import { COOL_BLUE } from 'colours';

export default function ResearchPage(props) {
  const { t } = useTranslation();
  const [isDesktop] = useCheckScreenSize();

  const useStyles = makeStyles(theme => ({
    list: {
      paddingBottom: '10px',
      wordWrap: 'break-word',
    },
    link: {
      color: COOL_BLUE,
    },
  }));
  const classes = useStyles();

  const getParagraphs = () => {
    return t('reporting.research.paragraph', { returnObjects: true });
  };

  return (
    <AssessmentPage
      headerMenuText={t('common.menu.mainItems.research')}
      bottomMenuSelectedOptionCode={'research'}
      desktopMenuIndex={7}
      secondaryHeaderWithBackNavigation={true}
    >
      <Box px={'20px'} py={'10px'}>
        <Grid container justify="center" direction="column">
          {isDesktop && (
            <Grid
              item
              xs={12}
              style={{ paddingTop: '60px', paddingBottom: '40px' }}
            >
              <Typography variant={'h2'}>
                {t('common.menu.mainItems.research')}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Box
              display={'block'}
              textAlign={'center'}
              style={{
                borderBottom: '1px Solid #ececec',
              }}
            >
              {getParagraphs().map((paragraph, ix) => {
                return (
                  <Typography
                    variant={'body1'}
                    key={ix}
                    style={{ paddingBottom: '15px' }}
                  >
                    {paragraph}
                  </Typography>
                );
              })}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ paddingTop: '30px', paddingBottom: '10px' }}
          >
            <Typography variant={'h2'}>
              {t('reporting.research.datasetsTitle')}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginBottom: isDesktop ? '0px' : '50px' }}
          >
            <ol style={{ paddingLeft: isDesktop ? 30 : 15 }}>
              <li className={classes.list}>
                <Typography
                  variant={'caption'}
                  style={{ fontStyle: 'normal' }}
                  className={classes.list}
                >
                  A cohort of patients with COVID-19 in a major teaching
                  hospital in Europe. Alberto M Borobia, Antonio J Carcas,
                  Francisco Arnalich, Rodolfo Alvarez-Sala, Jaime Montserrat,
                  Manuel Quintana, Juan C Figueira, Rosario M Torres
                  Santos-Olmo, Julio Garcia-Rodriguez, Alberto Martin-Vega,
                  Elena Ramirez, Antonio Buno, Gonzalo Martinez-Ales, Nicolas
                  Garcia-Arenzana, Concepcion Nunez Lopez, Milagros Marti de
                  Gracia, Francisco Moreno, Francisco Reinoso-Barbero, Alejandro
                  Martin-Quiros, Angelica Rivera, Jesus Mingorance, Carlos C
                  Carpio, Daniel Prieto Arribas, Esther Rey Cuevas, Maria C
                  Prados, Juan J Rios, Miguel Hernan, Jesus Frias, Jose R
                  Arribas, COVID@HULP working team. medRxiv 2020.04.29.20080853;
                  doi:{' '}
                  <a
                    href="https://doi.org/10.1101/2020.04.29.20080853"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.29.20080853
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  30-day mortality in patients hospitalized with COVID-19 during
                  the first wave of the Italian epidemic: a prospective cohort
                  study. Andrea Giacomelli, Anna Lisa Ridolfo, Laura Milazzo,
                  Letizia Oreni, Dario Bernacchia, Matteo Siano, Cecilia
                  Bonazzetti, Marco Schiuma, Alice Covizzi, Matteo Passerini,
                  Marco Piscaglia, Massimo Coen, Guido Gubertini, Giuliano
                  Rizzardini, Chiara Cogliati, Anna Maria Brambilla, Riccardo
                  Colombo, Antonio Castelli, Roberto Rech, Agostino Riva,
                  Alessandro Torre, Luca Meroni, Stefano Rusconi, Spinello
                  Antinori, Massimo Galli. medRxiv 2020.05.02.20088336; doi:
                  <a
                    href="https://doi.org/10.1101/2020.05.02.20088336"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.05.02.20088336
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Characteristics of ischaemic stroke associated with COVID-19,
                  United Kingdom, URL:
                  <a
                    href="https://jnnp.bmj.com/content/early/2020/04/30/jnnp-2020-323586#T1"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://jnnp.bmj.com/content/early/2020/04/30/jnnp-2020-323586#T1
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Clinical and historical features associated with severe
                  COVID-19 infection: a systematic review Jennifer L Pigoga,
                  Alexandra Friedman, Morgan Broccoli, Sarah Hirner, Antoinette
                  Vanessa Naidoo, Swasthi Singh, Kalin Werner, Lee A Wallis.
                  medRxiv 2020.04.23.20076653; doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.23.20076653"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.23.20076653
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Comorbidity and its impact on 1,590 patients with COVID-19 in
                  China: A Nationwide Analysis. Wei-jie Guan, doi:
                  <a
                    href="https://doi.org/10.1101/2020.02.25.20027664"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.02.25.20027664
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  COVID-19 Fatality and Comorbidity Risk Factors among Confirmed
                  Patients in Mexico. Patricio Solís, Hiram Carreňo. medRxiv
                  2020.04.21.20074591; doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.21.20074591"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.21.20074591
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  COVID-19 versus non-COVID-19 pneumonia: A retrospective cohort
                  study in Chengdu, China. Xiao-jin Li, Bing-Xing Shuai,
                  Zhong-Wei Zhang, Yan Kang. medRxiv 2020.04.28.20082784; doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.28.20082784"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.28.20082784
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  COVID-19: epidemiological update of April 23, 2020. Sante
                  Publique France.
                  <a
                    href="https://www.santepubliquefrance.fr/maladies-et-traumatismes/maladies-et-infections-respiratoires/infection-a-coronavirus/documents/bulletin-national/covid-19-point-epidemiologique-du-23-avril-2020"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://www.santepubliquefrance.fr/maladies-et-traumatismes/maladies-et-infections-respiratoires/infection-a-coronavirus/documents/bulletin-national/covid-19-point-epidemiologique-du-23-avril-2020
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Development and Validation of a Survival Calculator for
                  Hospitalized Patients with COVID-19.Todd J. Levy, Safiya
                  Richardson, Kevin Coppa, Douglas P. Barnaby, Thomas McGinn,
                  Lance B. Becker, Karina W. Davidson, Stuart L. Cohen, Jamie S.
                  Hirsch, Theodoros Zanos, Northwell &amp; Maimonides COVID-19
                  Research Consortium. medRxiv 2020.04.22.20075416; doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.22.20075416"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.22.20075416
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Epidemiology, clinical course, and outcomes of critically ill
                  adults with COVID-19 in New York City: a prospective cohort
                  study. Matthew J Cummings, Matthew R Baldwin, Darryl Abrams,
                  Samuel D Jacobson, Benjamin J Meyer, Elizabeth M Balough,
                  Justin G Aaron, Jan Claassen, LeRoy E Rabbani, Jonathan
                  Hastie, Beth R Hochman, John Salazar-Schicchi, Natalie H Yip,
                  Daniel Brodie, Max R O'Donnell., medRxiv 2020.04.15.20067157;
                  doi:{' '}
                  <a
                    href="https://doi.org/10.1101/2020.04.15.20067157"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.15.20067157
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Estimating Survival of Hospitalized COVID-19 Patients from
                  Admission Information. Todd J. Levy, Safiya Richardson, Kevin
                  Coppa, Douglas P. Barnaby, Thomas McGinn, Lance B. Becker,
                  Karina W. Davidson, Jamie S. Hirsch, Theodoros Zanos,
                  Northwell COVID-19 Research Consortium. doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.22.20075416"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.22.20075416
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Evaluating a Widely Implemented Proprietary Deterioration
                  Index Model Among Hospitalized COVID-19 Patients. Karandeep
                  Singh, Thomas S. Valley, Shengpu Tang, Benjamin Y. Li, Fahad
                  Kamran, Michael W. Sjoding, Jenna Wiens, Erkin Otles, John P.
                  Donnelly, Melissa Y. Wei, Jonathon P. McBride, Jie Cao,
                  Carleen Penoza, John Z. Ayanian, Brahmajee K. Nallamothu.
                  medRxiv 2020.04.24.20079012; doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.24.20079012"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.24.20079012
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Factors associated with hospitalization and critical illness
                  among 4,103 patients with COVID-19 disease in New York City,
                  Christopher M. Petrilli, Simon A. Jones, Jie Yang, Harish
                  Rajagopalan, Luke F. O'Donnell, Yelena Chernyak, Katie Tobin,
                  Robert J. Cerfolio, Fritz Francois, Leora I. Horwitz, medRxiv
                  2020.04.08.20057794; doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.08.20057794"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.08.20057794
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Features of 16,749 hospitalised UK patients with COVID-19
                  using the ISARIC WHO Clinical Characterisation Protocol.
                  Annemarie B Docherty, Ewen M Harrison, Christopher A Green,
                  Hayley E Hardwick, Riinu Pius, Lisa Norman, Karl A Holden,
                  Jonathan M Read, Frank Dondelinger, Gail Carson, Laura Merson,
                  James Lee, Daniel Plotkin, Louise Sigfrid, Sophie Halpin,
                  Clare Jackson, Carrol Gamble, Peter W Horby, Jonathan S
                  Nguyen-Van-Tam, Jake Dunning, Peter JM Openshaw, J Kenneth
                  Baillie, Malcolm Gracie Semple. medRxiv 2020.04.23.20076042;
                  doi:{' '}
                  <a
                    href="https://doi.org/10.1101/2020.04.23.20076042"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.23.20076042
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Gattinoni, L., Coppola, S., Cressoni, M., Busana, M., Rossi,
                  S., &amp; Chiumello, D. (2020). Covid-19 does not lead to a
                  &quot;typical&quot; acute respiratory distress syndrome.
                  American journal of respiratory and critical care medicine,
                  201(10), 1299-1300.
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Helms, J., Tacquard, C., Severac, F. et al. High risk of
                  thrombosis in patients with severe SARS-CoV-2 infection: a
                  multicenter prospective cohort study. Intensive Care Med 46,
                  1089–1098 (2020).{' '}
                  <a
                    href="https://doi.org/10.1007/s00134-020-06062-x"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1007/s00134-020-06062-x
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  ICNARC report on COVID-19 in critical care, 07 September 2020,
                  URL:{' '}
                  <a
                    href="https://www.icnarc.org/DataServices/Attachments/Download/499fd2a6-a7f1-ea11-912a-00505601089b"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://www.icnarc.org/DataServices/Attachments/Download/499fd2a6-a7f1-ea11-912a-00505601089b
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Liu, Songqiao and Luo, Huanyuan and Wang, Yuancheng and Wang,
                  Duolao and Ju, Shenghong and Yang, Yi, Characteristics and
                  Associations with Severity in COVID-19 Patients: A Multicentre
                  Cohort Study from Jiangsu Province, China (2/28/2020).
                  Available at SSRN:{' '}
                  <a
                    href="https://ssrn.com/abstract=3548753"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://ssrn.com/abstract=3548753
                  </a>{' '}
                  or
                  <a
                    href="http://dx.doi.org/10.2139/ssrn.3548753"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    http://dx.doi.org/10.2139/ssrn.3548753
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Early Short Course Corticosteroids in Hospitalized Patients
                  with COVID-19, Raef Fadel, Austin Morrison, Amit Vahia,
                  Zachary R Smith, Zohra Chaudhry, Pallavi Bhargava, Joseph
                  Miller, Rachel Kenney, George Alangaden, Mayur S Ramesh, Henry
                  Ford COVID-19 Management Task ForcemedRxiv
                  2020.05.04.20074609; doi:{' '}
                  <a
                    href="https://doi.org/10.1101/2020.05.04.20074609"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.05.04.20074609
                  </a>
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Presenting Characteristics, Comorbidities, and Outcomes Among
                  5700 Patients Hospitalized With COVID-19 in the New York City
                  Area. Richardson S, Hirsch JS, Narasimhan M, et al. JAMA.
                  2020;323(20):2052–2059. doi:10.1001/jama.2020.6775{' '}
                </Typography>
              </li>
              <li className={classes.list}>
                <Typography variant={'caption'} style={{ fontStyle: 'normal' }}>
                  Prevalence and Impact of Myocardial Injury in Patients
                  Hospitalized with COVID-19 Infection. Anuradha Lala, doi:
                  <a
                    href="https://doi.org/10.1101/2020.04.20.20072702"
                    target="_blank"
                    className={classes.link}
                    rel="noopener noreferrer"
                  >
                    https://doi.org/10.1101/2020.04.20.20072702
                  </a>
                </Typography>
              </li>
            </ol>
          </Grid>
        </Grid>
      </Box>
    </AssessmentPage>
  );
}
